// extracted by mini-css-extract-plugin
export var labelWrapper = "_bx-0";